enum PortfolioDragType {
  TOPIC = 'TOPIC',
  SUBTOPIC = 'SUBTOPIC',
  PART = 'PART',
  LEVEL = 'LEVEL',
}

export default PortfolioDragType;
